import React from "react";
import SubmittedCopyright from "../sumitted_copyright/SubmittedCopyright";

const ReconsiderationUnauthorizedCopyright = () => {
  const fileStatus = 35;
  const applicationPath = {
    copyright: "/admin/reconsideration-unauthorized-copyright",
    agreement: "/admin/reconsideration-unauthorized-agreement",
  };
  return (
    <SubmittedCopyright
      pageTitle={"অননুমোদন পুনর্বিবেচনা"}
      fileStatus={fileStatus}
      applicationPath={applicationPath}
      detailsRoute={"/admin/reconsideration-copyright-details"}
    />
  );
};

export default ReconsiderationUnauthorizedCopyright;
